var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinDrop = function SvgPinDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7394_4673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 3.16634C9.28634 3.16634 11.333 4.09967 11.333 6.59967C11.333 8.03967 10.1863 9.71301 7.99967 11.4797C5.81301 9.71301 4.66634 8.03301 4.66634 6.59967C4.66634 4.09967 6.71301 3.16634 7.99967 3.16634ZM7.99967 1.83301C5.81967 1.83301 3.33301 3.47301 3.33301 6.59967C3.33301 8.67967 4.88634 10.873 7.99967 13.1663C11.113 10.873 12.6663 8.67967 12.6663 6.59967C12.6663 3.47301 10.1797 1.83301 7.99967 1.83301Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 5.16699C7.26634 5.16699 6.66634 5.76699 6.66634 6.50033C6.66634 7.23366 7.26634 7.83366 7.99967 7.83366C8.3533 7.83366 8.69243 7.69318 8.94248 7.44313C9.19253 7.19309 9.33301 6.85395 9.33301 6.50033C9.33301 6.1467 9.19253 5.80756 8.94248 5.55752C8.69243 5.30747 8.3533 5.16699 7.99967 5.16699ZM3.33301 13.8337H12.6663V15.167H3.33301V13.8337Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7394_4673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
export default SvgPinDrop;